import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrending3"><Path fillRule="evenodd" clipRule="evenodd" d="M14.9982 6H21.9982V13H20.4982V8.57067L12.9978 16.0603L8.99816 12.0607L2.74816 18.3107L1.6875 17.25L8.99816 9.93934L12.9985 13.9397L19.4475 7.5H14.9982V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending3;
